import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { TicketLot } from '../../../core/models/event.models';

@Component({
  selector: 'app-ticket-lots',
  standalone: true,
  imports: [CommonModule],
  providers: [CurrencyPipe],
 templateUrl: './ticket-lots.component.html',
})
export class TicketLotsComponent {
  @Input({ required: true }) lots!: TicketLot[];
  /** Texto opcional ao lado do título (ex.: contagem regressiva). */
  @Input() badgeText: string | null = null;
  @Output() select = new EventEmitter<TicketLot>();

  trackById = (_: number, lot: TicketLot) => lot.id;
}
